/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { ContentInner } from './ContentInner'
import {
  ContentInnerFromJSON,
  ContentInnerFromJSONTyped,
  ContentInnerToJSON,
} from './ContentInner'
import type { FaqItem } from './FaqItem'
import { FaqItemFromJSON, FaqItemFromJSONTyped, FaqItemToJSON } from './FaqItem'

/**
 * Полный элемент инструкции (GET /instructions/{slug}): карточка + конструктор (все типы блоков, как в блоге, — схема Content) и привязанные частые вопросы; DTO — App\Service\Post\Content\Single\Data\InstructionBodyData. Пустой конструктор — [], не null
 * @export
 * @interface Instruction
 */
export interface Instruction {
  /**
   * Заголовок инструкции
   * @type {string}
   * @memberof Instruction
   */
  title: string
  /**
   * Slug инструкции
   * @type {string}
   * @memberof Instruction
   */
  slug: string
  /**
   * Дата публикации, null — не задана
   * @type {Date}
   * @memberof Instruction
   */
  publishedAt?: Date | null
  /**
   * Порядок сортировки (meta.extra.sort_order), null — не задан
   * @type {number}
   * @memberof Instruction
   */
  order?: number | null
  /**
   * Краткое описание (meta.extra.short_description), null — не задано
   * @type {string}
   * @memberof Instruction
   */
  shortDescription?: string | null
  /**
   *
   * @type {Array<ContentInner>}
   * @memberof Instruction
   */
  constructor: Array<ContentInner>
  /**
   * Привязанные частые вопросы (в порядке выбора в админке; элементы — схема FaqItem, единая с GET /faq)
   * @type {Array<FaqItem>}
   * @memberof Instruction
   */
  faq: Array<FaqItem>
}

/**
 * Check if a given object implements the Instruction interface.
 */
export function instanceOfInstruction(value: object): value is Instruction {
  if (!('title' in value) || value['title'] === undefined) return false
  if (!('slug' in value) || value['slug'] === undefined) return false
  if (!('constructor' in value) || value['constructor'] === undefined)
    return false
  if (!('faq' in value) || value['faq'] === undefined) return false
  return true
}

export function InstructionFromJSON(json: any): Instruction {
  return InstructionFromJSONTyped(json, false)
}

export function InstructionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Instruction {
  if (json == null) {
    return json
  }
  return {
    title: json['title'],
    slug: json['slug'],
    publishedAt:
      json['publishedAt'] == null ? undefined : new Date(json['publishedAt']),
    order: json['order'] == null ? undefined : json['order'],
    shortDescription:
      json['shortDescription'] == null ? undefined : json['shortDescription'],
    constructor: (json['constructor'] as Array<any>).map(ContentInnerFromJSON),
    faq: (json['faq'] as Array<any>).map(FaqItemFromJSON),
  }
}

export function InstructionToJSON(value?: Instruction | null): any {
  if (value == null) {
    return value
  }
  return {
    title: value['title'],
    slug: value['slug'],
    publishedAt:
      value['publishedAt'] == null
        ? undefined
        : (value['publishedAt'] as any).toISOString(),
    order: value['order'],
    shortDescription: value['shortDescription'],
    constructor: (value['constructor'] as Array<any>).map(ContentInnerToJSON),
    faq: (value['faq'] as Array<any>).map(FaqItemToJSON),
  }
}
